<template>
  <transition name="el-fade-in-linear">
    <div class="basicBox" :style="[{'z-index':zIndex?zIndex:''}]" v-show="!hidden">
      <div class="workFlowList" :style="[{'width':sence=='cert'||(sence=='PerfBudget'&&act_type!='notice')||sence=='taskDetails'?'90%':sence=='StaffList'?'70%':sence=='replacePrincipal'||sence=='changeApprover'||sence=='optionApprovalProcess'?'50%':''}]">
        <div class="title" :style="[{'white-space':sence=='dishesList'?'normal':''}]">
          <span>{{message}}{{sence=='PerfBudget'&&act_type=='warehouse'&&selectIdList.length>0?'-已选'+selectIdList.length+'个品项':''}}</span>
          <div class="outputBtn" v-if="sence=='score_details'" @click="getScoreDetails(1)">导出</div>
        </div>
        <div class="message_list" v-if="sence=='workFlow'">
          <div class="message_inner_top">
            <div class="table_title" style="width:12%;">工作流名称</div>
            <div class="table_title" style="width:8%;">工作流类型</div>
            <div class="table_title" style="width:10%;">开始时间</div>
            <div class="table_title" style="width:10%;">结束时间</div>
            <div class="table_title" style="width:20%;">总项目概况</div>
            <div class="table_title" style="width:8%;">待处理</div>
            <div style="width:32%;display:flex;align-items:center;">
              <div class="table_title" style="width:40%;">反馈项</div>
              <div class="table_title" style="width:30%;">状态</div>
              <div class="table_title" style="width:30%;">操作</div>
            </div>
          </div>
          <div class="message_inner">
            <div class="msg_item" v-for="(item,i) in content_list" :key="i" :style="[{'background':i%2==0?'rgba(255,107,64,0.07)':''}]">
              <div class="item_1" style="width:12%;"><!--工作流名称-->
                <div>{{item.name}}</div>
              </div>
              <div class="item_1" style="width:8%;"><!--工作流类型-->
                <div>{{item.type_name}}</div>
              </div>
              <div class="item_1" style="width:10%;"><!--开始时间-->
                <div>{{item.created_at}}</div>
              </div>
              <div class="item_1" style="width:10%;"><!--结束时间-->
                <div>{{item.finished_at}}</div>
              </div>
              <div class="item_1" style="width:20%;flex-direction:column;justify-content:center;"><!--总项目概况-->
                <div style="width:100%;display:flex;align-items:center;margin-bottom:10px;">
                  <span>天：</span>
                  <div style="display:flex;flex:1;align-items:center;justify-content:space-between;">
                    <span style="white-space:nowrap;">理:{{item.theory_days}}</span>
                    <span style="white-space:nowrap;">实:{{item.actual_days}}</span>
                    <span style="white-space:nowrap;">超:{{item.over_due_days}}</span>
                  </div>
                </div>
                <div style="width:100%;display:flex;align-items:center;margin-top:10px;">
                  <span>项：</span>
                  <div style="display:flex;flex:1;align-items:center;justify-content:space-between;">
                    <span style="white-space:nowrap;">进度:{{item.get_items}}/{{item.total_items}}</span>
                    <span style="white-space:nowrap;">超:{{item.over_due_items}}</span>
                  </div>
                </div>
              </div>
              <div class="item_1" style="width:8%;"><!--待处理-->
                <div>{{item.pending}}项</div>
              </div>
              <div class="item_2" style="width:32%">
                <div class="item_detail" v-for="(second,z) in item.list_data" :key="z" :style="z==item.list_data.length-1?'border:0':''">
                  <div class="detail_first" style="width:40%;"><!--反馈项-->
                    <div>{{second.point_desc}}</div>
                  </div>
                  <div class="detail_first" style="width:30%;"><!--状态-->
                    <div>{{second.status_desc}}</div>
                  </div>
                  <div class="detail_first" style="width:30%;"><!--操作-->
                    <div class="option_btn" @click="handleAction('confirm',i,z)">{{confirmText}}</div>
                    <div class="detail_btn" @click="handleAction('cancel',i,z)">{{cancelText}}</div>
                  </div>
                </div>
              </div>
            </div>
            <noData v-if="content_list.length==0"></noData>
          </div>
        </div>
        <iframe style="width:100%;height:70vh;" :src="iframeUrl" frameborder="0" v-if="sence=='course'||sence=='homework'||sence=='cert'||sence=='dishesList'||sence=='taskDetails'||sence=='practiceDetails'||sence=='feedbackDetails'||sence=='StaffList'||sence=='feedbackItem'"></iframe>
        <div class="common_list" v-if="sence=='exam'">
          <div class="common_searchInner">
            <div class="searchContent">
              <div class="search_box">
                <div class="search_item">
                  <span>考试名称：</span>
                  <el-input type="text" v-model="practicalName" placeholder="根据考试名称搜索" style="flex:1;"></el-input>
                </div>
              </div>
              <div class="box_search">
                <div class="searchBtn" @click="search(1)">重置</div>
                <div class="searchBtn2" @click="search(2)">查询</div>
              </div>
            </div>
          </div>
          <div class="common_inner">
            <div class="common_inner_top">
              <div class="top_title_box">
                <div class="inner_top_title">
                  <div class="desc_options" style="width:10%;">
                    <el-checkbox class="c_box" :value="isAll" @change="selectAll"></el-checkbox>
                  </div>
                  <div class="desc_options" style="width:30%;">考试名称</div>
                  <div class="desc_options" style="width:20%;">总分</div>
                  <div class="desc_options" style="width:20%;">考试项目数量</div>
                  <div class="desc_options" style="width:20%;">考试时长</div>
                </div>
              </div>
            </div>
            <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
              <div class="item_1" style="width:10%">
                <el-checkbox class="c_box" :value="isSelect(i)" @change="select(i)"></el-checkbox>
              </div>
              <div class="item_1" style="width:30%">{{item.name}}</div>
              <div class="item_1" style="width:20%">{{item.total_score}}</div>
              <div class="item_1" style="width:20%">{{item.nums}}</div>
              <div class="item_1" style="width:20%">{{item.test_duration}}分钟</div>
            </div>
            <noData v-if="content_list.length==0"></noData>
          </div>
          <div class="pagination">
            <el-pagination background layout="total,sizes,prev,pager,next" @size-change="p_handleSizeChange" @current-change="p_handleCurrentChange" :page-sizes="[10,50,100]" :page-size="p_per_page" :total="p_total_msg" :current-page="p_page" :page-count="p_total_page"></el-pagination>
          </div>
        </div>
        <div class="common_list" v-if="sence=='score_details'||sence=='depart_details'">
          <div class="common_basic_msg" style="margin:0;">
            <div class="basicInner" v-if="sence=='score_details'">
              <div class="basic_item">
                <div class="desc">姓名:</div>
                <div class="desc_content">{{obj.emp_name}}</div>
              </div>
              <div class="basic_item">
                <div class="desc">今日获得学分:</div>
                <div class="desc_content">{{obj.today_score}}</div>
              </div>
              <div class="basic_item">
                <div class="desc">累计学分:</div>
                <div class="desc_content">{{obj.total_score}}</div>
              </div>
            </div>
            <div class="basicInner" v-if="sence=='depart_details'">
              <div class="basic_item">
                <div class="desc">门店:</div>
                <div class="desc_content">{{obj.department_name}}</div>
              </div>
              <div class="basic_item">
                <div class="desc">学员人数:</div>
                <div class="desc_content">{{obj.emp_nums}}</div>
              </div>
              <div class="basic_item">
                <div class="desc">平均学分:</div>
                <div class="desc_content">{{obj.avg_score}}</div>
              </div>
            </div>
          </div>
          <div class="common_searchInner">
            <div class="searchContent">
              <div class="search_box">
                <div class="search_item">
                  <span>时间段：</span>
                  <el-date-picker
                    style="flex:1"
                    value-format="yyyy-MM-dd"
                    v-model="score_time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="search_item" v-if="sence=='score_details'">
                  <span>学习类型：</span>
                  <el-select v-model="score_class" filterable placeholder="请选择" style="flex:1;">
                    <el-option :value="-1" label="全部"></el-option>
                    <el-option :value="0" label="岗位地图"></el-option>
                    <el-option :value="1" label="学习项目"></el-option>
                  </el-select>
                </div>
                <div class="search_item" v-if="sence=='score_details'">
                  <span>学分分类：</span>
                  <el-select v-model="score_category" filterable placeholder="请选择" style="flex:1;">
                    <el-option :value="-1" label="全部"></el-option>
                    <el-option :value="0" label="学习项目"></el-option>
                    <el-option :value="1" label="项目阶段"></el-option>
                    <el-option :value="2" label="选修自学课件"></el-option>
                  </el-select>
                </div>
                <div class="search_item" v-if="sence=='depart_details'">
                  <span>学员姓名：</span>
                  <el-input type="text" style="flex:1" v-model="emp_name" placeholder="输入学员姓名检索"></el-input>
                </div>
                <div class="search_item" v-if="sence=='depart_details'">
                  <span>岗位：</span>
                  <el-input type="text" style="flex:1" v-model="position_name" placeholder="输入岗位名称检索"></el-input>
                </div>
              </div>
              <div class="box_search">
                <div class="searchBtn" @click="search(1)">重置</div>
                <div class="searchBtn2" @click="search(2)">查询</div>
              </div>
            </div>
          </div>
          <div class="common_inner" style="max-height:40vh" v-if="sence=='score_details'">
            <div class="common_inner_top">
              <div class="top_title_box">
                <div class="inner_top_title">
                  <div class="desc_options" v-for="(item,i) in scoreTitle" :key="i" :style="[{'width':item.width+'%'}]">{{item.name}}</div>
                </div>
              </div>
            </div>
            <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
              <div class="item_1" v-for="(it,k) in scoreTitle" :key="'k'+k" :style="[{'width':it.width+'%'}]" :title="dataDesc(1,i,k)">{{dataDesc(2,i,k)}}</div>
            </div>
            <noData v-if="content_list.length==0"></noData>
          </div>
          <div class="common_inner" style="max-height:40vh" v-if="sence=='depart_details'">
            <div class="common_inner_top">
              <div class="top_title_box">
                <div class="inner_top_title">
                  <div class="desc_options" v-for="(item,i) in scoreTitle" :key="i" :style="[{'width':item.width+'%'}]">{{item.name}}</div>
                </div>
              </div>
            </div>
            <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
              <div class="item_1" v-for="(it,k) in scoreTitle" :key="'k'+k" :style="[{'width':it.width+'%'}]" :title="dataDesc(1,i,k)">{{dataDesc(2,i,k)}}</div>
            </div>
            <noData v-if="content_list.length==0"></noData>
          </div>
        </div>
        <div class="inp_inner" v-if="sence=='replacePrincipal'||sence=='changeApprover'||sence=='optionApprovalProcess'">
          <div class="inp_item">
            <div class="tit_desc">
              <div class="desc_info" v-if="sence=='replacePrincipal'">原负责人员：</div>
              <div class="desc_info" v-if="sence=='changeApprover'">{{id==1?'原提交人员':'原审批人员'}}：</div>
              <div class="desc_info" v-if="sence=='optionApprovalProcess'">原审批人员：</div>
              <el-select
                style="flex:1"
                v-model="originEmp"
                filterable
                remote
                reserve-keyword
                :placeholder="originEmp_tip(1)"
                :remote-method="remoteMethod1"
                :loading="false">
                <el-option v-for="(item,i) in options1" :key="i" :label="item.department_name[0]?item.name+'-'+item.department_name[0].top_name+item.department_name[0].department_name+'-'+item.position+'-'+item.mobile:item.name+'-'+item.type_desc+'-'+item.position+'-'+item.mobile" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inp_item" v-if="sence=='optionApprovalProcess'">
            <div class="tit_desc">
              <div class="desc_info">操作类型：</div>
              <div style="display:flex;align-items:center;flex:1;">
                <el-radio v-model="act_type" :label="0">通过审批(所选的原审批人员下所有待审批记录，将一并通过审批)</el-radio>
                <el-radio v-model="act_type" :label="1">替换审批人</el-radio>
              </div>
            </div>
          </div>
          <div class="inp_item" v-if="sence=='changeApprover'&&id==1">
            <div class="tit_desc">
              <div class="desc_info">报销单状态：</div>
              <div style="display:flex;align-items:center;flex:1;">
                <el-radio v-model="status" :label="-1">已驳回</el-radio>
                <el-radio v-model="status" :label="0">待审批</el-radio>
                <el-radio v-model="status" :label="2">待支付</el-radio>
                <el-radio v-model="status" :label="3">已支付</el-radio>
              </div>
            </div>
          </div>
          <div class="inp_item" v-if="sence=='replacePrincipal'||sence=='changeApprover'||(sence=='optionApprovalProcess'&&act_type==1)">
            <div class="tit_desc">
              <div class="desc_info" v-if="sence!='changeApprover'">新审批人员：</div>
              <div class="desc_info" v-if="sence=='changeApprover'">{{id==1?'新提交人员':'新审批人员'}}：</div>
              <el-select
                style="flex:1"
                v-model="newEmp"
                filterable
                remote
                reserve-keyword
                :placeholder="newEmp_tip(1)"
                :remote-method="remoteMethod2"
                :loading="false">
                <el-option v-for="(item,i) in options2" :key="i" :label="item.emp_name+'-'+item.depart_name+'-'+item.pos_name+'-'+item.mobile" :value="item.emp_id"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="inp_inner" v-if="sence=='assignTrainProject'">
          <el-checkbox-group v-model="sendType" @change="handleChange" style="width:auto;margin-bottom:12px;">
            <el-checkbox :label="0">按姓名搜索</el-checkbox>
            <el-checkbox :label="1">按员工名单</el-checkbox>
          </el-checkbox-group>
          <input type="file" v-show="false" id="empBox" accept="file" @change="getEmpFile" :multiple="false"/>
          <div class="inp_item" v-if="sendType[0]==0">
            <div class="tit_desc">
              <div class="desc_info" style="margin-right:12px;">要派发的人员：</div>
              <el-select
                style="flex:1"
                v-model="ids"
                filterable
                multiple
                remote
                reserve-keyword
                :placeholder="send_tip"
                :remote-method="remoteMethod1"
                :loading="false">
                <el-option v-for="(item,i) in options1" :key="i" :label="item.department_name&&item.department_name[0]?item.name+'-'+item.department_name[0].top_name+item.department_name[0].department_name+'-'+item.position+'-'+item.mobile:item.emp_name+'-'+item.status_desc+'-'+item.pos_name+'-'+item.mobile" :value="item.id?item.id:item.emp_id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inp_item" v-if="sendType[0]==1">
            <div class="tit_desc">
              <div class="desc_info" style="margin-right:12px;">派发员工：</div>
              <div style="display:flex;align-items:center;">
                <el-popover
                  placement="right"
                  width="550"
                  trigger="click">
                  <el-table height="250" :data="saveArr" border>
                    <el-table-column prop="emp_name" label="姓名" width="100"></el-table-column>
                    <el-table-column prop="gender" label="性别" width="50"></el-table-column>
                    <el-table-column prop="mobile" label="手机号" width="100"></el-table-column>
                    <el-table-column prop="depart_name" label="所属单位" width="100"></el-table-column>
                    <el-table-column prop="position_name" label="所在岗位" width="100"></el-table-column>
                    <el-table-column label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button slot="reference" size="small" type="primary" style="margin-right:10px;" v-show="saveArr.length>0">{{'已选'+saveArr.length+'个员工'}}</el-button>
                </el-popover>
                <el-popover placement="right" width="350" trigger="click">
                  <div style="width:100%;display:flex;align-items:center;">
                    <el-cascader
                        collapse-tags
                         style="width:100%;"
                        :show-all-levels="false"
                        ref="cascader"
                        v-model="ids"
                        :options="content_list"
                        :props="{expandTrigger: 'click',children:'array',label:'name',value:'id',multiple:true,checkStrictly:false,emitPath:false}"
                        placeholder="按门店导出员工名单">
                        <template slot-scope="{ node, data }">
                          <span>{{ data.name }}</span>
                          <span v-if="data.array&&data.array.length>0"> ({{ data.array.length }}) </span>
                        </template>
                    </el-cascader>
                    <el-button size="small" type="primary" @click="openEmpList(3)" :class="{'gray_btn':ids.length==0}">确认导出</el-button>
                  </div>
                  <el-button slot="reference" size="small" type="primary" style="margin-right:10px;">导出模板</el-button>
                </el-popover>
                <el-button slot="reference" size="small" type="primary" @click="openEmpList(2)">导入</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="common_list" v-if="sence=='PerfBudget'">
          <div class="common_inner">
            <div class="common_inner_top">
              <div class="top_title_box">
                <div class="inner_top_title">
                  <div class="desc_options" :style="[{'width':it.width+'%'}]" v-for="(it,k) in title_list" :key="k">
                    <el-checkbox class="c_box" :value="isAll" @change="selectAll" v-if="it.key=='select'"></el-checkbox>
                    <span v-if="it.key!='select'" v-html="it.name"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
              <div class="item_1" :style="[{'width':it.width+'%'}]" v-for="(it,k) in title_list" :key="k" :title="descBox(1,content_list[i],title_list[k])">
                <el-checkbox class="c_box" :value="isSelect(i)" @change="select(i)" v-if="it.key=='select'" :disabled="(id==1&&item.apply_button!=1)||(id==2&&item.audit_status!=-1)"></el-checkbox>
                <span v-if="it.key=='sort'">{{i+1}}</span>
                <span v-if="it.key!='select'&&it.key!='options'&&it.key!='sort'">{{descBox(2,content_list[i],title_list[k])}}</span>
                <div class="option_btn" v-if="it.key=='options'&&act_type=='notice'" @click="toOrderDetails(i)">去确认</div>
              </div>
            </div>
            <noData v-if="content_list.length==0"></noData>
          </div>
          <div class="pagination" v-if="act_type!='warehouse'&&act_type!='notice'">
            <el-pagination background layout="total,sizes,prev,pager,next" @size-change="p_handleSizeChange" @current-change="p_handleCurrentChange" :page-sizes="[10,50,100]" :page-size="p_per_page" :total="p_total_msg" :current-page="p_page" :page-count="p_total_page"></el-pagination>
          </div>
        </div>
        <div class="message_list" v-if="sence=='userList'">
          <div class="common_searchInner">
            <div class="searchContent">
              <div class="search_box">
                <div class="search_item">
                  <span>姓名：</span>
                  <el-input type="text" v-model="emp_name" placeholder="根据姓名搜索" style="flex:1;"></el-input>
                </div>
              </div>
              <div class="box_search">
                <div class="searchBtn" @click="search(1)">重置</div>
                <div class="searchBtn2" @click="search(2)">查询</div>
              </div>
            </div>
          </div>
          <div class="common_list" style="overflow-x: hidden;">
            <div class="common_inner">
              <div class="common_inner_top">
                <div class="top_title_box">
                  <div class="inner_top_title">
                    <div class="desc_options" :style="[{'width':it.width+'%'}]" v-for="(it,k) in title_list" :key="k">
                      <el-checkbox class="c_box" :value="isAll" @change="selectAll" v-if="it.key=='select'&&act_type!=1"></el-checkbox>
                      <span v-if="it.key!='select'" v-html="it.name"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
                <div class="item_1" :style="[{'width':it.width+'%'}]" v-for="(it,k) in title_list" :key="k" :title="descBox(1,content_list[i],title_list[k])">
                  <el-checkbox class="c_box" :value="isSelect(i)" @change="select(i)" v-if="it.key=='select'" :disabled="act_type==1&&selectList.length>0"></el-checkbox>
                  <span v-if="it.key!='select'">{{descBox(2,content_list[i],title_list[k])}}</span>
                </div>
              </div>
              <noData v-if="content_list.length==0"></noData>
            </div>
            <div class="pagination">
              <el-pagination background layout="total,sizes,prev,pager,next" @size-change="p_handleSizeChange" @current-change="p_handleCurrentChange" :page-sizes="[10,50,100]" :page-size="p_per_page" :total="p_total_msg" :current-page="p_page" :page-count="p_total_page"></el-pagination>
            </div>
          </div>
        </div>
        <div class="message_list" v-if="sence=='regularization'" style="width:100%;">
          <div class="common_list" style="overflow-x: hidden;max-height:50vh;overflow-y:auto;">
            <div class="common_inner">
              <div class="common_inner_top">
                <div class="top_title_box">
                  <div class="inner_top_title">
                    <div class="desc_options" :style="[{'width':it.width+'%'}]" v-for="(it,k) in regTitleList" :key="k">
                      <span v-html="it.name"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="common_msg_item" v-for="(item,i) in content_list" :key="i" :class="i%2==0?'item_1_active':''">
                <div class="item_1" :style="[{'width':it.width+'%'}]" v-for="(it,k) in regTitleList" :key="k" :title="regDesc(1,item,it)">
                  <span v-if="it.key!='options'" v-html="regDesc(2,item,it)"></span>
                  <div class="option_btn" v-if="it.key=='options'" @click="openAuditInner(item)">去审批</div>
                </div>
              </div>
              <noData v-if="content_list.length==0"></noData>
            </div>
          </div>

          <!-- 内联审批弹框（process_status==0 部门负责人审批阶段，简单弹框，复刻 /archive_approval 第一步） -->
          <transition name="el-fade-in-linear">
            <div class="reg_audit_mask" v-if="innerAuditItem">
              <div class="reg_audit_inner">
                <div class="audit_dialog_title">转正提醒审批</div>
                <div class="common_list">
                  <div class="common_inner" style="border-right:1px solid #e5e5e5;overflow:hidden;">
                    <div class="common_basic_msg" style="margin:0;">
                      <div class="not_hover_msg_item" style="border-top:1px solid #e5e5e5;">
                        <div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">员工姓名：</span><span style="flex:1;color:#333;">{{auditForm.emp_name||'—'}}</span></div>
                      </div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">入职日期：</span><span style="flex:1;color:#333;">{{auditForm.join_date||'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">转正日期：</span><span style="flex:1;color:#333;">{{auditForm.regular_date||'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">试用期(月)：</span><span style="flex:1;color:#333;">{{auditForm.probation_period!==''&&auditForm.probation_period!==null?auditForm.probation_period:'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">现合同时间：</span><span style="flex:1;color:#333;">{{auditForm.current_contract&&auditForm.current_contract.length===2?auditForm.current_contract[0]+' 至 '+auditForm.current_contract[1]:'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">原合同时间：</span><span style="flex:1;color:#333;">{{auditForm.original_contract&&auditForm.original_contract.length===2?auditForm.original_contract[0]+' 至 '+auditForm.original_contract[1]:'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">试用期薪资：</span><span style="flex:1;color:#333;">{{auditForm.probation_period_salary!==''&&auditForm.probation_period_salary!==null?auditForm.probation_period_salary:'—'}}</span></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">转正薪资：</span><span style="flex:1;color:#333;">{{auditForm.regular_salary!==''&&auditForm.regular_salary!==null?auditForm.regular_salary:'—'}}</span></div></div>
                      <div class="not_hover_msg_item" style="border-top:1px solid #e5e5e5;"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">审批结果：</span>
                        <el-select v-model="auditForm.audit_result_0" placeholder="请选择审批结果" style="flex:1;">
                          <el-option label="正常转正" value="1"></el-option>
                          <el-option label="延期转正" value="2"></el-option>
                          <el-option label="不予转正" value="3"></el-option>
                        </el-select></div></div>
                      <div class="not_hover_msg_item"><div class="item_1" style="width:100%;"><span style="font-weight:bold;min-width:120px;text-align:right;">审批备注：</span>
                        <el-input type="textarea" :rows="3" style="flex:1;" v-model="auditForm.audit_remark_0" placeholder="审批结果选择「延期转正 / 不予转正」时必填驳回原因"></el-input></div></div>
                    </div>
                  </div>
                </div>
                <div class="btn">
                  <div class="btn_item" @click="closeAuditInner">取消</div>
                  <div class="btn_item" style="background:#FF6B40;color:#FFFFFF" :class="{'gray_btn':auditSubmitting}" @click="submitAuditInner">{{auditSubmitting?'提交中...':'提交审批'}}</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="btn">
          <div class="btn_item active" @click="goApprovalList" v-if="sence=='regularization'">前往审批列表</div>
          <div class="btn_item active" @click="confirmChange" v-if="sence=='replacePrincipal'||sence=='changeApprover'||sence=='optionApprovalProcess'">保存</div>
          <div class="btn_item active" @click="confirmSend" v-if="sence=='assignTrainProject'">确认派发</div>
          <div class="btn_item" @click="closeBox">{{cancelText}}</div>
          <div class="btn_item" v-if="sence=='userList'&&act_type==1&&selectList.length>0" @click="selectList=[]">清空已选：{{selectList[0].emp_name}}</div>
          <div class="btn_item active" @click="confirmChoose" v-if="isRequest&&!id||(isRequest&&id=='supply')">{{confirmText}}</div>
          <div class="btn_item active" @click="audit(2)" v-if="sence=='PerfBudget'&&id==1">通过</div>
          <div class="btn_item active" @click="audit(1)" v-if="sence=='PerfBudget'&&id==1">驳回</div>
          <div class="btn_item active" @click="audit(3)" v-if="sence=='PerfBudget'&&id==2">删除</div>
          <div class="btn_item active" @click="submitItems" :class="[{'gray_btn':selectIdList.length==0}]" v-if="sence=='PerfBudget'&&act_type=='warehouse'">确认选择</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
	import Vue from 'vue';
	import store from "../../store";
	import qs from 'qs';
	import router from "../../router";
	import { auditRegularArchives, notifyArchiveRefresh } from '@/api/archive';
	export default {
		data(){
			return {
        id:'',//sence=optionApprovalProcess的时候当type用
        ids:[],
        sence:'',
				hidden: true,
				message: '标题',
				showCancel: true,
				confirmText:'确定',
				cancelText:'关闭',
				confirm: null,
				cancel: null,
        content_list:[],
        title_list:[],
        innerAuditItem:null,
        auditForm:{
          id:'', emp_name:'', join_date:'', regular_date:'', probation_period:'',
          current_contract:[], original_contract:[], probation_period_salary:'', regular_salary:'',
          audit_result_0:'', audit_remark_0:''
        },
        auditSubmitting:false,
        saveList:[],
        practicalName:'',
        p_page:1,
        p_total_page:0,
        p_total_msg:0,
        p_per_page:10,
        selectList:[],
        score_time:[],
        score_class:-1,
        score_category:-1,
        obj:{},
        emp_name:'',
        position_name:'',
        originEmp:'',
        newEmp:'',
        options1:[],
        options2:[],
        act_type:0,
        depart_id:'',
        title_list:[],
        status:-1,
        zIndex:null,
        sendType:[0],
        saveArr:[]
			}
		},
    watch:{
      hidden(e){
        if(e){
          setTimeout(() => {
            this.$el.remove();
            this.$destroy();
          },300);
        }
      }
    },
		computed:{
      send_tip(){
        if(this.act_type=='practice'){
          return '请搜索选择或导入要派发实操考试的人员（多选）'
        }else{
          return '请搜索选择或导入要派发学习项目的人员（多选）'
        }
      },
      // 转正提醒待审批列表表头（与 /archive_approval 审批页一致；缺失字段由 regDesc 补默认）
      regTitleList(){
        return [
          { name:'流水号', width:13, key:'serial_number' },
          { name:'提交人', width:11, key:'add_emp_name' },
          { name:'员工', width:11, key:'emp_name' },
          { name:'提交时间', width:14, key:'created_at' },
          { name:'审批人', width:13, key:'audit_emp_name' },
          { name:'状态', width:10, key:'status_desc' },
          { name:'流程状态', width:14, key:'process_status_desc' },
          { name:'操作', width:14, key:'options' }
        ]
      },
      descBox(){
        return function(e,item,it){
          if(e==1){
            var key=it.key;
            var str=it.name;
            var name=str.replace('<br/>','');
            return name+'：'+this.descBox(2,item,it);
          }else if(e==2){
            var key=it.key;
            if(key=='sort'){
              return  '';
            }else if(key=='gender'){
              return item[key]==1?'男':item[key]==2?'女':item[key]
            }else if(key=='depart_name'){
              return item.depart_name||item.department_name
            }else if(key=='pos_name'){
              return item.pos_name||item.position_name
            }else if(key=='options'||key=='status'||key=='select'){
              return '';
            }else if(key=='data_list'&&this.act_type=='notice'){
              return item[key].length;
            }else if(item[key]==undefined){
              return '未对接'
            }else{
              return item[key]
            }
          }
        }
      },
      scoreTitle(){
        if(this.sence=='score_details'){
          return [
            {name:'最新获得日期',key:'date',width:10},
            {name:'学习类型',key:'self_study_desc',width:20},
            {name:'学习名称',key:'data_name',width:30},
            {name:'学分分类',key:'score_type_desc',width:20},
            {name:'学分',key:'score',width:20}
          ]
        }else if(this.sence=='depart_details'){
          return [
            {name:'排名',key:'sort',width:10},
            {name:'姓名',key:'emp_name',width:10},
            {name:'职级',key:'rank_name',width:10},
            {name:'岗位',key:'position_name',width:20},
            {name:'岗位学分',key:'stage_score',width:20},
            {name:'自学学分',key:'self_study_score',width:20},
            {name:'总学分',key:'total_score',width:20}
          ]
        }
      },
      dataDesc(){
        return function(e,i,k){
          var item=this.content_list[i];
          var title=this.scoreTitle[k].name;
          var key=this.scoreTitle[k].key;
          if(e==1){
            if(item[key]==undefined){
              return ''
            }else if(key=='score'||key=='total_score'||key=='stage_score'||key=='self_study_score'){
              return title+'：'+item[key]+'分'
            }else{
              return title+'：'+item[key]
            }
          }else if(e==2){
            if(item[key]==undefined){
              return ''
            }else if(key=='score'||key=='total_score'||key=='stage_score'||key=='self_study_score'){
              return item[key]+'分'
            }else{
              return item[key]
            }
          }
        }
      },
      isAll(){
        var isAll=false;
        for(var key in this.content_list){
          if(this.selectIdList.indexOf(this.content_list[key].id)!=-1){
            isAll=true;
          }else{
            isAll=false;
            return
          }
        }
        return isAll;
      },
      isSelect(){
      	return function(i){
      		var id=this.content_list[i].id;
      		if(this.selectIdList.indexOf(id)!=-1){
      			return true
      		}else{
      			return false
      		}
      	}
      },
      selectIdList(){
      	var arr=[];
      	for(var key in this.selectList){
      		arr.push(this.selectList[key].id)
      	}
      	return arr;
      },
      isRequest(){
        if(this.sence=='userList'||this.sence=='course'||this.sence=='onlineFile'||this.sence=='exam'||this.sence=='homework'||this.sence=='practiceDetails'||this.sence=='StaffList'||this.sence=='feedbackItem'||this.sence=='feedbackDetails'||this.sence=='cert'){
          return true;
        }else{
          return false;
        }
      },
      iframeUrl(){
        var host=window.location.host;
        if(host.indexOf('localhost')!=-1){
          host='http://'+host
        }else{
          host='https://'+host
        }
        console.log(host)
        if(this.sence=='course'){
          if(this.originEmp='inspect'){
            return this.id?host+'/#/onlinere_source?isChoose=1&isInspect=1&id='+this.id:host+'/#/onlinere_source?isChoose=1&isInspect=1'
          }else{
            return this.id?host+'/#/onlinere_source?isChoose=1&id='+this.id:host+'/#/onlinere_source?isChoose=1'
          }
        }else if(this.sence=='homework'){
          return this.id?host+'/#/practical_exam?isChoose=1&id='+this.id:host+'/#/practical_exam?isChoose=1'
        }else if(this.sence=='cert'){
          return this.id?host+'/#/auth_manage?isChoose=1&id='+this.id:host+'/#/auth_manage?isChoose=1'
        }else if(this.sence=='dishesList'){
          return host+'/#/dish_basic_data?isChoose=1'
        }else if(this.sence=='taskDetails'){
          return host+'/#/task_details?isChoose=1&id='+this.id
        }else if(this.sence=='practiceDetails'){
          return this.id?host+'/#/practice_audit_list?isChoose=1&id='+this.id:host+'/#/practice_audit_list?isChoose=1'
        }else if(this.sence=='feedbackDetails'){
          return this.id?host+'/#/feedback_audit_list?isChoose=1&id='+this.id:host+'/#/feedback_audit_list?isChoose=1'
        }else if(this.sence=='feedbackItem'){
          return this.id?host+'/#/feedback_list?isChoose=1&id='+this.id:host+'/#/feedback_list?isChoose=1'
        }else if(this.sence=='StaffList'){
          if(this.id){
            if(this.id=='options'){
              return host+'/#/'+this.originEmp+'?isChoose=1&id='+this.id
            }
          }else{
            return host+'/#/'+this.originEmp+'?isChoose=1'
          }
        }
      },
      originEmp_tip(){
        return function(e){
          if(e==1){
            if(this.sence=='replacePrincipal'){
              return '请输入原负责人员姓名检索'
            }else if(this.sence=='changeApprover'){
              if(this.id==1){
                return '请输入原提交人员姓名检索'
              }else{
                return '请输入原审批人员姓名检索'
              }
            }else{
              return '请输入原审批人员姓名检索'
            }
          }else if(e==2){
            if(this.sence=='replacePrincipal'){
              return '请选择原负责人员'
            }else if(this.sence=='changeApprover'){
              if(this.id==1){
                return '请选择原提交人员'
              }else{
                return '请选择原审批人员'
              }
            }else{
              return '请选择原审批人员'
            }
          }
        }
      },
      newEmp_tip(){
        return function(e){
          if(e==1){
            if(this.sence=='replacePrincipal'){
              return '请输入新负责人员姓名检索'
            }else if(this.sence=='changeApprover'){
              if(this.id==1){
                return '请输入新提交人员姓名检索'
              }else{
                return '请输入新审批人员姓名检索'
              }
            }else{
              return '请输入新审批人员姓名检索'
            }
          }else if(e==2){
            if(this.sence=='replacePrincipal'){
              return '请选择新负责人员'
            }else if(this.sence=='changeApprover'){
              if(this.id==1){
                return '请选择新提交人员'
              }else{
                return '请选择新审批人员'
              }
            }else{
              return '请选择新审批人员'
            }
          }
        }
      }
		},
    mounted() {
      window.addEventListener('message', this.handleChildMessage);
      if(this.sence=='exam'||this.sence=='PerfBudget'||this.sence=='userList'){
        this.getData()
      }else if(this.sence=='score_details'||this.sence=='depart_details'){
        this.getScoreDetails()
      }
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleChildMessage);
    },
		methods: {
      toOrderDetails(i){
        var param={
          ids:JSON.stringify([this.content_list[i].id])
        }
        this.$http.post('/v1/notice/readReiceiveNotice',param).then(res => {
          if(res.data.status==1) {
            this.confirm(this.content_list[i].order_id);
            if(this.content_list.length==1){
              this.content_list.splice(i,1)
              this.$nextTick(()=>{
                this.hidden=true;
              })
            }else{
              this.content_list.splice(i,1)
            }
          }else{
            this.$message.error({message:res.data.message});
          }
        }).catch((res)=>{});
      },
      submitItems(){
        if(this.selectList.length==0){
          this.$message('请勾选品项')
        }else{
          this.hidden=true;
          this.confirm(this.selectList)
        }
      },
      handleDel(row){
        var list=this.saveArr;
        var index=list.findIndex(it=>it.emp_id==row.emp_id);
        this.saveArr.splice(index,1);
      },
      getEmpFile(){
        var id="#empBox"
        var fileObj = document.querySelector(id).files;
        var param=new FormData();
        param.append('myExcel',fileObj[0]);
        this.$http.upload('/v1/study/importEmpList',param).then(res => {
          if(res.data.status==1) {
            document.querySelector(id).value='';
            this.saveArr=res.data.data;
          }else{
            document.querySelector(id).value='';
            this.$alert(res.data.message,'提示',{confirmButtonText:'确定'});
          }
        }).catch((res)=>{});
      },
      openEmpList(e){
        if(e==1||e==2){
          var id="#empBox"
          var fileBox = document.querySelector(id);
          fileBox.click();
        }else if(e==3){
          if(this.ids.length==0){
            this.$message('请先选择要导出人员名单的门店')
          }else{
            var param={
              type:this.act_type=='practice'?1:0,
              id:this.id?this.id:0,
              depart_ids:JSON.stringify(this.ids)
            }
            this.$http.get('/v1/study/exportEmpList?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
              if(res.data.status==1) {
                window.open(res.data.data.url)
              }else{
                this.$message.error({message:res.data.message});
              }
            }).catch((res)=>{});
          }
        }
      },
      handleChange(value){
        if(value.length>1){
          this.sendType.splice(0, 1); // 移除第一个选中的项
        }
      },
      audit(e){
        var s_1=this.act_type=='SalaryBudget'?'薪酬':'绩效'
        if(this.selectList.length==0){
          this.$message(this.id==1?'请选择要审批的'+s_1:'请选择要删除的'+s_1)
        }else{
          if(e==1||e==2){
            var desc=e==1?'是否确认驳回所选的'+s_1+'审批？（'+this.selectList.length+'条）':'是否确认通过所选'+s_1+'审批？（'+this.selectList.length+'条）';
            var remark_desc=e==1?'请输入驳回备注':'请输入审核备注(选填)'
            const h=this.$createElement;
            var _this = this;
            // 创建独立响应式数据（避免污染组件数据）
            const state = Vue.observable({
              process_continue:0,
              remarkContent: '',
              forceUpdate: () => {} // 用于强制更新的方法占位
            })
            // 创建按钮的渲染函数
            const renderOptions = () => h('div', { class: 'account_inner' }, [
              h('div', {
                class: { 'account_btn': true, 'active': state.process_continue === 1 },
                on: { click: () => updateState({ process_continue: 1 }) }
              }, '是'),
              h('div', {
                class: { 'account_btn': true, 'active': state.process_continue === 0 },
                on: { click: () => updateState({ process_continue: 0 }) }
              }, '否')
            ])
            // 创建输入框的渲染函数
            const renderInput = () => h('el-input', {
              props: { value: state.remarkContent },
              on: {
                input: (val) => updateState({ remarkContent: val })
              }
            })
            // 状态更新方法（核心）
            const updateState = (newState) => {
              Object.assign(state, newState)
              state.forceUpdate() // 触发重新渲染
            }
            if(e==1){// 创建弹窗内容
              var content = h(Vue.extend({
                render() {
                  state.forceUpdate = this.$forceUpdate.bind(this) // 绑定强制更新方法
                  return h('div', { style: 'width:100%;display:flex;flex-direction:column' }, [
                    h('span', { style: 'font-size:12px;color:rgba(0,0,0,0.6)' }, desc),
                    h('br'),
                    h('span', { style: 'font-size:12px;color:rgba(0,0,0,0.6)' }, '驳回后是否继续审批流程'),
                    renderOptions(),
                    h('br'),
                    renderInput()
                  ])
                }
              }))
            }else{
              var content = h(Vue.extend({
                render() {
                  return h('div', { style: 'width:100%;display:flex;flex-direction:column' }, [
                    h('span', { style: 'font-size:12px;color:rgba(0,0,0,0.6)' }, desc),
                    h('br'),
                    renderInput()
                  ])
                }
              }))
            }
            this.$msgbox({
                title:s_1+'批量审批', //弹框标题
                message:content,
                showCancelButton: true,
                closeOnClickModal: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                  if(action === 'confirm') {
                    if(e==1&&!state.remarkContent){
                      _this.$message(remark_desc)
                    }else{
                      done()
                    }
                  }else {
                    done();
                  }
                }
            }).then(_ => {
              var param={
                type:1,
                budget_ids:JSON.stringify(_this.selectIdList),
                status:e==1?2:1,
                remark:state.remarkContent,
                process_continue:state.process_continue
              }
              var post_url=_this.act_type=='SalaryBudget'?'/v1/attendance/auditSalaryBudget?':'/v1/attendance/auditPerfBudget?'
              _this.$http.post(post_url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
                if(res.data.status==1){
                  _this.$message({
                    message:res.data.message,
                    type: 'success'
                  });
                  _this.confirm('ok')
                  _this.hidden=true;
                }else{
                  _this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }).catch(_ => {});
          }else if(e==3){
            this.$confirm('是否确认删除？','已选'+this.selectList.length+'条记录',{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(()=>{
              var param={
                type:1,
                budget_ids:JSON.stringify(this.selectIdList)
              };
              var post_url=_this.act_type=='SalaryBudget'?'/v1/attendance/delSalaryBudget':'/v1/attendance/delPerfBudget'
              this.$http.del(post_url,param).then(res => {
                if(res.data.status==1) {
                  this.$message({
                    message:'操作成功',
                    type: 'success'
                  });
                  this.confirm('ok')
                  this.hidden=true;
                }else{
                  this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }).catch(()=>{})
          }
        }
      },
      confirmChange(){
        if(!this.originEmp){
          this.$message(this.originEmp_tip(2))
        }else if((this.sence=='replacePrincipal'&&!this.newEmp)||(this.sence=='changeApprover'&&!this.newEmp)||(this.sence=='optionApprovalProcess'&&!this.newEmp&&this.act_type==1)){
          this.$message(this.newEmp_tip(2))
        }else{
          this.$confirm('是否确认保存变更？',this.message,{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            if(this.sence=='replacePrincipal'){
              var param={
                type:this.id,
                from_emp_id:this.originEmp,
                to_emp_id:this.newEmp
              }
              var url='/v1/inspect/replacePrincipal?'
              this.$http.put(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
                if(res.data.status==1){
                  this.$message({
                    message:res.data.message,
                    type: 'success'
                  });
                  this.confirm('ok')
                  this.hidden=true;
                }else{
                  this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }else{
              if(this.sence=='changeApprover'){
                var param={
                  act_type:this.id,
                  from_emp_id:this.originEmp,
                  to_emp_id:this.newEmp
                }
                if(this.ids.length>0){
                  param.ids=JSON.stringify(this.ids)
                }
                if(this.id==1){
                  param.status=this.status
                }
                var url='/v1/finance/changeApprover?'
              }else if(this.sence=='optionApprovalProcess'){
                var param={
                  type:this.id,
                  act_type:this.act_type,
                  from_emp_id:this.originEmp,
                  to_emp_id:this.newEmp
                }
                if(this.ids.length>0){
                  param.ids=JSON.stringify(this.ids)
                }
                var url='/v1/attendance/optionApprovalProcess?'
              }
              this.$http.post(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
                if(res.data.status==1){
                  this.$message({
                    message:res.data.message,
                    type: 'success'
                  });
                  this.closeBox()
                }else{
                  this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }
          }).catch(()=>{})
        }
      },
      confirmSend(){
        if(this.sendType[0]==0&&this.ids.length==0){
          this.$message(this.send_tip)
        }else if(this.sendType[0]==1&&this.saveArr.length==0){
          this.$message(this.send_tip)
        }else{
          var len=this.sendType[0]==0?this.ids.length:this.saveArr.length;
          if(this.act_type=='practice'){
            var str='是否确认派发该实操考试给'
          }else{
            var str='是否确认派发该学习项目给'
          }
          this.$confirm(str+len+'个员工？',this.message,{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            if(this.act_type=='practice'){
              var param={
                practice_ids:JSON.stringify([this.id])
              }
              if(this.sendType[0]==0){
                param.emp_ids=JSON.stringify(this.ids)
              }else if(this.sendType[0]==1){
                var drr=this.saveArr.map(it=>it.emp_id);
                param.emp_ids=JSON.stringify(drr)
              }
              var url='/v1/study/createStudyPractice?'
              this.$http.post(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
                if(res.data.status==1){
                  this.$message({
                    message:res.data.message,
                    type: 'success'
                  });
                  this.closeBox()
                }else{
                  this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }else{
              var param={
                id:this.id
              }
              if(this.sendType[0]==0){
                param.emp_ids=JSON.stringify(this.ids)
              }else if(this.sendType[0]==1){
                var drr=this.saveArr.map(it=>it.emp_id);
                param.emp_ids=JSON.stringify(drr)
              }
              var url='/v1/study/assignTrainProject?'
              this.$http.post(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
                if(res.data.status==1){
                  this.$message({
                    message:res.data.message,
                    type: 'success'
                  });
                  this.closeBox()
                }else{
                  this.$message.error({message:res.data.message});
                }
              }).catch((res)=>{});
            }
          }).catch(()=>{})
        }
      },
      remoteMethod1(e){
        var param={
          keyword:e!=undefined?e:'',

        }
        if(this.sence=='assignTrainProject'){
          param.type=1;
          var url='/v1/employee/getManageDepartEmployeeList?'
        }else{
          param.page=1;
          param.pageSize=100;
          var url='/v1/employee/employees?'
        }
        this.$http.get(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
          if(res.data.status==1){
            if(this.sence=='assignTrainProject'){
              this.options1=res.data.data;
            }else{
              this.options1=res.data.data.list;
            }
          }
        }).catch((res)=>{});
      },
      remoteMethod2(e){
        var param={
          keyword:e!=undefined?e:'',
          page:1,
          pageSize:100
        }
        var url='/v1/employee/getManageDepartEmployeeList?'
        this.$http.get(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
          if(res.data.status==1){
            this.options2=res.data.data.data;
          }
        }).catch((res)=>{});
      },
      search(e){
        if(e==1){
          this.position_name='';
          this.emp_name='';
          this.practicalName='';
          this.score_time=[];
          this.score_class=-1;
          this.score_category=-1;
        }
        this.p_page=1;
        if(this.sence=='exam'||this.sence=='userList'){
          this.getData();
        }else if(this.sence=='score_details'||this.sence=='depart_details'){
          this.getScoreDetails()
        }
      },
      p_handleCurrentChange(e){
        this.p_page=e;
        this.getData();
      },
      p_handleSizeChange(e){
        this.p_per_page=e;
        this.p_page=1;
        this.getData();
      },
      selectAll(){
        if(!this.isAll){
          if(this.sence=='PerfBudget'&&this.id==1){//待审核
            for(var key in this.content_list){
              if(this.selectIdList.indexOf(this.content_list[key].id)==-1){
                if(this.content_list[key].apply_button==1){//待审核
                  this.selectList.push(this.content_list[key])
                }
              }
            }
          }else if(this.sence=='PerfBudget'&&this.id==2){//删除
            for(var key in this.content_list){
              if(this.selectIdList.indexOf(this.content_list[key].id)==-1){
                if(this.content_list[key].audit_status==-1){//删除
                  this.selectList.push(this.content_list[key])
                }
              }
            }
          }else{
            for(var key in this.content_list){
              if(this.selectIdList.indexOf(this.content_list[key].id)==-1){
                this.selectList.push(this.content_list[key])
              }
            }
          }
        }else{
          for(var key in this.content_list){
            for(var i in this.selectList){
              if(this.selectList[i].id==this.content_list[key].id){
                this.selectList.splice(i,1);
              }
            }
          }
        }
      },
      select(i){
        var id=this.content_list[i].id;
        if(this.selectIdList.indexOf(id)!=-1){
        	var index=this.selectIdList.indexOf(id);
        	this.selectList.splice(index,1);
        }else{
        	this.selectList.push(this.content_list[i]);
        }
      },
      handleChildMessage(event) {
        console.log('子页面回复:', event.data.data);
        if(this.sence=='course'){
          this.saveList=event.data.data;
        }else if(this.sence=='homework'){
          this.saveList=event.data.data;
        }else if(this.sence=='feedbackItem'){
          this.saveList=event.data.data;
        }else if(this.sence=='cert'){
          this.saveList=event.data.data;
        }else if(this.sence=='StaffList'){
          this.saveList=event.data.data;
        }else if(this.sence=='dishesList'){
          this.$confirm('<'+this.practicalName+'>-是否确认匹配成本卡做法别名？',event.data.data.card_name,{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            var param={
              card_names:JSON.stringify(this.saveList),            //成本卡做法别名 格式：[{"wm_source":0,"item_name":"牛肉","item_practice":"麻辣"},{"wm_source":1,"item_name":"牛腩","item_practice":"五香"}]
              dishes_card_id:event.data.data.id        //成本卡ID
            }
            this.$http.put('/v1/tool/matchDishesCardAlias',param).then(res => {
              if(res.data.status==1){
                this.$message({
                  message:res.data.message,
                  type: 'success'
                });
                this.hidden=true;
                this.confirm(event.data.data)
              }else{
                this.$message.error({message:res.data.message});
              }
            }).catch((res)=>{});
          }).catch(()=>{})
        }
      },
      confirmChoose(){
        if(this.sence=='course'){
          if(this.saveList.length==0){
            this.$message('请选择要添加的课程')
          }else{
            this.hidden=true;
            this.confirm(this.saveList)
          }
        }else if(this.sence=='exam'){
          if(this.selectList.length==0){
            this.$message('请选择要添加的考试')
          }else{
            this.hidden=true;
            this.confirm(this.selectList)
          }
        }else if(this.sence=='homework'){
          if(this.saveList.length==0){
            this.$message('请选择要添加的实操作业')
          }else{
            this.hidden=true;
            this.confirm(this.saveList)
          }
        }else if(this.sence=='feedbackItem'){
          if(this.saveList.length==0){
            this.$message('请选择要添加的反馈项目')
          }else{
            this.hidden=true;
            this.confirm(this.saveList)
          }
        }else if(this.sence=='StaffList'){
          if(this.saveList.length==0){
            this.$message('请选择要添加的人员名单')
          }else{
            this.hidden=true;
            this.confirm(this.saveList)
          }
        }else if(this.sence=='cert'){
          if(this.saveList.length==0){
            this.$message('请选择证书')
          }else{
            this.hidden=true;
            this.confirm(this.saveList)
          }
        }else if(this.sence=='userList'){
          if(this.selectList.length==0){
            this.$message('请选择人员')
          }else{
            this.hidden=true;
            this.confirm(this.selectList)
          }
        }
      },
      getData(){
        if(this.sence=='exam'){
          var param={
            name:this.practicalName,
            page:this.p_page,
            pageSize:this.p_per_page
          }
          this.$http.get('/v1/question/getTestTempList?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
            if(res.data.status==1) {
              this.content_list=res.data.data.data;
              this.p_total_page=res.data.data.last_page;
              this.p_total_msg=res.data.data.total;
            }else{
              this.$message.error({message:res.data.message});
            }
          }).catch((res)=>{});
        }else if(this.sence=='PerfBudget'){
          if(this.act_type=='warehouse'&&this.ids.length>0){
            for(var key in this.content_list){
              if(this.ids.indexOf(this.content_list[key].id)!=-1){
                this.selectList.push(this.content_list[key])
              }
            }
          }else if(this.act_type=='notice'){
            return
          }else{
            var param={
              depart_id:this.depart_id,
              month:this.score_time,
              audit_status:this.id==1?0:-2,
              is_self:1,
              page:this.p_page,
              pageSize:this.p_per_page
            }
            if(this.act_type=='SalaryBudget'){
              var url='/v1/attendance/getSalaryBudgetApprovalList?';
            }else{
              var url='/v1/attendance/getPerfBudgetApprovalList?';
            }
            this.$http.get(url+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
              if(res.data.status==1) {
                if(res.data.data.data){
                  this.content_list=res.data.data.data;
                  this.p_total_page=res.data.data.last_page;
                  this.p_total_msg=res.data.data.total;
                }else{
                  this.content_list=[]
                }
              }else{
                this.$message.error({message:res.data.message});
              }
            }).catch((res)=>{});
          }
        }else if(this.sence=='userList'){
          var param={
            keyword:this.emp_name,
            page:this.p_page,
            pageSize:this.p_per_page
          }
          this.$http.get('/v1/employee/getManageDepartEmployeeList?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
            if(res.data.status==1) {
              if(res.data.data.data){
                this.content_list=res.data.data.data;
                this.p_total_page=res.data.data.last_page;
                this.p_total_msg=res.data.data.total;
              }else{
                this.content_list=[]
              }
            }else{
              this.$message.error({message:res.data.message});
            }
          }).catch((res)=>{});
        }
      },
      getScoreDetails(e){
        if(this.sence=='score_details'){
          var param={
            is_export:e==1?1:0,
            emp_id:this.id,
            self_study:this.score_class,              //学习类型：-1-全部，0-岗位地图，1-学习项目
            score_type:this.score_category,   //学分分类：-1-全部，0-学习项目，1-项目阶段，2-选修自学课件
            date:this.score_time.toString()              //日期 格式：2024-12-04,2024-12-05
          }
          this.$http.get('/v1/study/getScoreRankDetail?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
            if(res.data.status==1) {
              if(e==1){
                window.open(res.data.data.url);
              }else{
                this.obj=res.data.data;
                this.content_list=res.data.data.list;
              }
            }else{
              this.$message.error({message:res.data.message});
            }
          }).catch((res)=>{});
        }else if(this.sence=='depart_details'){
          var param={
            type:0,
            depart_id:this.id,        //门店id 格式：[478,489]
            position_name:this.position_name,     //岗位
            emp_name:this.emp_name,          //人员名称
            date:this.score_time.toString(),              //日期 格式：2024-12-04,2024-12-05
            is_export:e==1?1:0
          }
          this.$http.get('/v1/study/getScoreRankList?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(res => {
            if(res.data.status==1) {
              if(e==1){
                window.open(res.data.data.url);
                return
              }else{
                if(res.data.data){
                  this.content_list=res.data.data;
                }else{
                  this.content_list=[];
                }
              }
            }else{
              this.$message.error({message:res.data.message});
            }
          }).catch((res)=>{});
        }
      },
      closeBox(){
        this.hidden=true;
        if(this.sence=='workFlow'){
          this.$local.set('pastTime',new Date().getTime())
        }else if(this.sence=='PerfBudget'&&this.act_type=='notice'){
          this.$local.set('dealTime',new Date().getTime())
        }else if(this.sence=='regularization'){
          this.$local.set('regRemindTime',new Date().getTime())
        }
      },
      // ===== 转正提醒待审批（sence='regularization'）=====
      // 列表单元格渲染：复用 /archive_approval 表头，缺失字段按审批语义补默认值
      regDesc(e, item, it){
        if(e==1){
          return it.name + '：' + this.regDesc(2, item, it)
        }
        var key = it.key
        if(key==='options') return ''
        if(key==='status_desc') return '审批中'
        if(key==='process_status_desc') return '待部门负责人审批'
        var val = item[key]
        if(val===undefined||val===null||val==='') return '-'
        return val
      },
      // 打开内联审批弹框（复刻 /archive_approval 的 process_status==0 简单弹框）
      openAuditInner(item){
        this.auditForm = {
          id: item.id,
          emp_name: item.emp_name,
          join_date: item.join_date || '',
          regular_date: item.regular_date || '',
          probation_period: item.probation_period != null ? item.probation_period : '',
          current_contract: (item.current_contract_start && item.current_contract_end) ? [item.current_contract_start, item.current_contract_end] : [],
          original_contract: (item.original_contract_start && item.original_contract_end) ? [item.original_contract_start, item.original_contract_end] : [],
          probation_period_salary: item.probation_period_salary != null ? item.probation_period_salary : '',
          regular_salary: item.regular_salary != null ? item.regular_salary : '',
          audit_result_0: '',
          audit_remark_0: ''
        }
        this.innerAuditItem = item
      },
      closeAuditInner(){
        this.innerAuditItem = null
      },
      // 审批提交：仅 id / audit_result_0 / audit_remark_0（接口说明2 #7 简化版）
      submitAuditInner(){
        if(!this.auditForm.audit_result_0){ this.$message({message:'请选择审批结果'}); return }
        var r = parseInt(this.auditForm.audit_result_0, 10)
        if(r>1 && !this.auditForm.audit_remark_0){
          this.$message({message:'审批结果选择「延期转正 / 不予转正」时，备注必填'}); return
        }
        this.auditSubmitting = true
        var payload = {
          audit_result_0: r,
          audit_remark_0: this.auditForm.audit_remark_0 || ''
        }
        auditRegularArchives(this.auditForm.id, payload).then(res=>{
          this.auditSubmitting = false
          if(res.data.status==1){
            this.$message({message: res.data.message||'审批成功', type:'success'})
            var idx = this.content_list.findIndex(x=>x.id===this.auditForm.id)
            if(idx>-1) this.content_list.splice(idx,1)
            this.innerAuditItem = null
            notifyArchiveRefresh() // 通知审批列表页自动刷新
            if(this.content_list.length===0){ this.hidden = true } // 全部审完→关闭外层弹框
          }else{
            this.$message.error({message: res.data.message})
          }
        }).catch(()=>{ this.auditSubmitting = false })
      },
      // 前往审批列表页（/archive_approval）
      goApprovalList(){
        this.hidden = true
        router.push({ path: '/archive_approval' })
      },
			handleAction(action,i,k) {
				if(action == 'confirm'){
          if(this.sence=='workFlow'){
            var item=this.content_list[i];
            item.k=k;
            this.$local.set('temporaryData',item)
          }
					this.hidden=true;
					this.confirm();
				}else{//取消
          if(this.sence=='workFlow'){//不再提醒
            var item=this.content_list[i];
            var param={
              id:item.list_id,
              item_id:item.list_data[k].item_id,
            }
            this.$http.post('/v1/workflow/dealWorkflowNotice',param).then(res => {
              if(res.data.status==1){
                this.$message({
                  message:res.data.message,
                  type: 'success'
                });
                this.content_list[i].list_data.splice(k,1);
                if(this.content_list[i].list_data.length==0){
                  this.content_list.splice(i,1)
                }
                if(this.content_list.length==0){
                  this.hidden=true;
                }
                this.$getMyNoticeList();
              }else{
                this.$alert(res.data.message,'提示',{confirmButtonText:'确定'});
              }
            }).catch((res)=>{});
          }else{
            this.hidden = true;
            this.cancel();
          }
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @use '../../../static/css/commonList.scss';
	.basicBox{
		width:100%;
		height:100vh;
		overflow-y:scroll;
		z-index:998;
		position: fixed;
		top:0;
		left:0;
		right:0;
		background:rgba(0,0,0,0.3);
		display:flex;
		flex-direction:column;
		align-items:center;
		justify-content:center;
    .workFlowList{
      width:1200px;
      display:flex;
      flex-direction:column;
      align-items:center;
      background:#ffffff;
      border-radius:4px;
      padding:20px;
      box-sizing:border-box;
      justify-content:center;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      .title{
        width:100%;
        font-size:20px;
        font-weight:bold;
        white-space:nowrap;
        color:rgba(0,0,0,0.85);
        user-select:none;
        text-align:center;
        margin-bottom:20px;
        position: relative;
        .outputBtn{
          font-size:14px;
          color:#ffffff;
          white-space:nowrap;
          user-select: none;
          cursor: pointer;
          padding:5px 12px;
          box-sizing:border-box;
          background:#FF6B40;
          border-radius:4px;
          border: 1px solid #FF6B40;
          position:absolute;
          top:0;
          bottom:0;
          right:0;
          z-index:200;
          display:flex;
          align-items:center;
        }
      }
      .message_list{
        width:100%;
        max-height:65vh;
        display:flex;
        overflow-y:scroll;
        flex-direction:column;
        align-items:center;
        .message_inner_top{
          width:100%;
          display:flex;
          align-items: center;
          justify-content:space-between;
          border-bottom:1px solid rgba(0,0,0,0.06);
          background:rgb(250,250,250);
          position:sticky;
          top:0;
          .table_title{
            padding:20px 0;
            box-sizing:border-box;
            font-size:14px;
            color:rgba(0,0,0,0.65);
            white-space:nowrap;
            cursor: default;
            font-weight:bold;
            display:flex;
            flex-direction:column;
            align-items:center;
          }
        }
        .message_inner{
          width:100%;
          display:-webkit-box;
          flex-direction:column;
          .msg_item{
            width:100%;
            height:auto;
            display:flex;
            box-sizing:border-box;
            border-bottom:1px solid rgba(0, 0, 0, 0.06);
            border-left:1px solid rgba(0, 0, 0, 0.06);
            border-right:1px solid rgba(0, 0, 0, 0.06);
            cursor: default;
            .item_1{
              width:13%;
              height:100%;
              display:flex;
              align-items:center;
              justify-content:center;
              font-size:14px;
              color:rgba(0,0,0,0.65);
              word-break:break-word;
              border-right:1px solid #EDEDED;
              padding:16px 10px;
              box-sizing:border-box;
              transition: 0.2s;
              text-align:center;
            }
            .item_2{
              height:auto;
              display:flex;
              flex-direction:column;
              cursor: default;
              transition: 0.3s;
              font-size:14px;
              color:rgba(0,0,0,0.65);
              .item_detail{
                width:100%;
                height:100%;
                display:flex;
                border-bottom:1px solid #EDEDED;
                .detail_first{
                  width:100%;
                  height:auto;
                  display:flex;
                  align-items:center;
                  justify-content:center;
                  word-break:break-word;
                  padding:16px 10px;
                  box-sizing:border-box;
                  border-right:1px solid #EDEDED;
                  flex-wrap:wrap;
                  .option_btn{
                    font-size:14px;
                    color:#FFFFFF;
                    white-space:nowrap;
                    user-select: none;
                    cursor: pointer;
                    padding:5px 12px;
                    box-sizing:border-box;
                    background:#FF6B40;
                    border: 1px solid #FF6B40;
                    border-radius:4px;
                    margin:5px;
                    transition: 0.3s;
                  }
                  .detail_btn{
                    font-size:14px;
                    color:#FF6B40;
                    white-space:nowrap;
                    user-select: none;
                    cursor: pointer;
                    padding:5px 12px;
                    box-sizing:border-box;
                    background:rgba(255, 107, 64, 0.07);
                    border: 1px solid #FF6B40;
                    border-radius:4px;
                    margin:5px;
                    transition: 0.3s;
                  }
                }
              }
            }
            .item_3{
              width:5%;
              height:100%;
              display:flex;
              align-items:center;
              flex-wrap:wrap;
              justify-content:center;
              border-right:1px solid #EDEDED;
              padding:10px;
              box-sizing:border-box;
              .option_btn{
                font-size:14px;
                color:#FFFFFF;
                white-space:nowrap;
                user-select: none;
                cursor: pointer;
                padding:5px 12px;
                box-sizing:border-box;
                background:#FF6B40;
                border: 1px solid #FF6B40;
                border-radius:4px;
                margin:5px;
                transition: 0.3s;
              }
              .detail_btn{
                font-size:14px;
                color:#FF6B40;
                white-space:nowrap;
                user-select: none;
                cursor: pointer;
                padding:5px 12px;
                box-sizing:border-box;
                background:rgba(255, 107, 64, 0.07);
                border: 1px solid #FF6B40;
                border-radius:4px;
                margin:5px;
                transition: 0.3s;
              }
            }
          }
          .msg_item:hover{
            background:#FF6B40!important;
            .item_1{
              color:#FFFFFF;
            }
            .item_2{
              background:#FF6B40;
              color:#FFFFFF;
              .item_detail{
                .detail_first{
                  .option_btn{
                    border: 1px solid #FFFFFF!important;
                  }
                  .detail_btn{
                    color:#FFFFFF!important;
                    border: 1px solid #FFFFFF!important;
                  }
                }
              }
            }
            .item_3{
              .option_btn{
                border: 1px solid #FFFFFF!important;
              }
              .detail_btn{
                color:#FFFFFF!important;
                border: 1px solid #FFFFFF!important;
              }
            }
          }
        }
      }
      .inp_inner{
        width:100%;
        display:flex;
        flex-direction:column;
        margin:10px 0;
        .inp_item{
          width:100%;
          display:flex;
          align-items:center;
          margin-bottom:20px;
          .tit_desc{
            width:100%;
            display:flex;
            align-items:center;
            .desc_info{
              width:100px;
              font-size:16px;
              white-space:nowrap;
              color:rgba(0,0,0,0.85);
              text-align:right;
              cursor: default;
            }
            .setType{
              width:80%;
              display:flex;
              align-items: center;
              font-size:16px;
              white-space:nowrap;
              color:rgba(0,0,0,0.85);
              text-align:left;
              cursor: default;
              .set_msg{
                display:flex;
                align-items:center;
                .checkBox{
                  display:flex;
                  align-items:center;
                  cursor:pointer;
                  .content_inner{
                    width:20px;
                    height:20px;
                    display:flex;
                    background:#FFFFFF;
                    align-items:center;
                    justify-content:center;
                    border:1px solid #DCDFE6;
                    border-radius:4px;
                    transition:0.3s;
                  }
                  .content_label{
                    font-size:16px;
                    color:rgba(0,0,0,0.85);
                    white-space:nowrap;
                    margin-left:6px;
                    transition:0.3s;
                  }
                }
                .active_box{
                  .content_inner{
                    background:#FF6B40!important;
                  }
                  .content_label{
                    color:#FF6B40!important;
                  }
                }
              }
            }
            .memberList{
              width:70%;
              display:flex;
              align-items:center;
              flex-wrap:wrap;
              .memberItem{
                font-size:14px;
                color:#FF6B40;
                white-space:nowrap;
                user-select: none;
                cursor: pointer;
                padding:5px 12px;
                box-sizing:border-box;
                background:#FFFFFF;
                border: 1px solid #FF6B40;
                border-radius:4px;
                margin-right:16px;
                position:relative;
              }
              .add_user{
                font-size:14px;
                color:#FFFFFF;
                white-space:nowrap;
                user-select: none;
                cursor: pointer;
                padding:5px 12px;
                box-sizing:border-box;
                background:#FF6B40;
                border: 1px solid #FF6B40;
                border-radius:4px;
              }
            }
          }
        }
      }
      .btn{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        margin-top:20px;
        .btn_item{
          font-size:16px;
          color:#FF6B40;
          white-space:nowrap;
          user-select: none;
          cursor: pointer;
          padding:5px 20px;
          box-sizing:border-box;
          background: rgba(255, 107, 64, 0.07);
          border: 1px solid #FF6B40;
          border-radius:4px;
          margin:0 20px;
          &.active{
            background: #FF6B40;
            color:#ffffff;
          }
        }
      }
    }
	}
  /* ===== 转正提醒内联审批弹框（sence='regularization'）===== */
  .reg_audit_mask{
    position:fixed;
    inset:0;
    z-index:10000;
    background:rgba(0,0,0,0.45);
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
  }
  .reg_audit_inner{
    width:780px;
    max-height:90vh;
    overflow-y:auto;
    display:flex;
    flex-direction:column;
    align-items:center;
    background:#ffffff;
    border-radius:4px;
    padding:28px 20px;
    box-sizing:border-box;
    justify-content:center;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
  }
  .reg_audit_inner .audit_dialog_title{
    width:100%;
    font-size:20px;
    font-weight:bold;
    white-space:nowrap;
    color:rgba(0,0,0,0.85);
    user-select:none;
    margin-bottom:12px;
    text-align:center;
  }
  /* 页面私有类 not_hover_msg_item / common_basic_msg 在 alert.vue 作用域无定义，这里本地兜底布局 */
  .reg_audit_inner .common_basic_msg .not_hover_msg_item{
    display:flex;
    align-items:center;
    border-top:1px solid #e5e5e5;
    padding:8px 0;
    box-sizing:border-box;
  }
  .reg_audit_inner .common_basic_msg .not_hover_msg_item .item_1{
    width:100%;
    display:flex;
    align-items:center;
  }
  .reg_audit_inner .btn{
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-top:20px;
  }
  .reg_audit_inner .btn .btn_item{
    font-size:16px;
    color:#FF6B40;
    white-space:nowrap;
    user-select:none;
    cursor:pointer;
    padding:5px 20px;
    box-sizing:border-box;
    background:rgba(255,107,64,0.07);
    border:1px solid #FF6B40;
    border-radius:4px;
    margin:0 20px;
  }
  .reg_audit_inner .gray_btn{ opacity:.6; pointer-events:none; }
</style>
